import { useAccount } from "../../app/session";
import type { KonsolenRolle } from "./konsole-nav";

/**
 * Rolle der angemeldeten Person in der Betreiber-Konsole (Vertrieb-Konsole, Inhaber 02.11.2026). Nur für Navigation und
 * Knöpfe; jede Aktion prüft die Datenbank selbst. Ohne Angabe (älteres Konto-Objekt, Render-Proben) gilt Admin, wenn das Konto
 * Plattform-Admin ist, sonst Vertrieb; Entwicklung nur ausdrücklich (0500), nie als Rückfall.
 */
export function useKonsolenRolle(): KonsolenRolle {
  const { account } = useAccount();
  if (account?.platformRole === "developer") return "developer";
  if (account?.platformRole === "admin" || (account?.platformRole === undefined && account?.isPlatformAdmin)) return "admin";
  return "sales";
}
